import React from 'react';
import { Check } from 'lucide-react';
import { PillarConfig, PillarRating } from '../types/alignment';
import { cn } from '../utils/cn';

interface PillarCardProps {
  pillar: PillarConfig;
  rating: PillarRating;
  isRecommended?: boolean;
  isSelected?: boolean;
  onClick: () => void;
}

export function PillarCard({ pillar, rating, isRecommended, isSelected, onClick }: PillarCardProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'relative w-full p-6 rounded-lg border-2 text-left transition-all hover:shadow-lg',
        isSelected
          ? 'border-teal-600 bg-teal-50 shadow-md'
          : 'border-gray-300 bg-white hover:border-teal-400'
      )}
    >
      {isRecommended && (
        <div className="absolute top-3 right-3 px-3 py-1 bg-amber-100 text-amber-800 text-xs font-semibold rounded-full">
          Recommended
        </div>
      )}

      {isSelected && (
        <div className="absolute top-3 right-3 w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center">
          <Check className="w-5 h-5 text-white" />
        </div>
      )}

      <div className="space-y-3">
        <h3 className="text-xl font-bold text-gray-900">{pillar.name}</h3>

        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-600">Your rating:</span>
          <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-800 font-semibold rounded-lg">
            {rating} / 5
          </span>
        </div>

        <p className="text-sm text-gray-600">{pillar.description}</p>

        <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
          <div
            className="bg-teal-600 h-2 rounded-full transition-all"
            style={{ width: `${(rating / 5) * 100}%` }}
          />
        </div>
      </div>
    </button>
  );
}
